// QueryClient singleton. The rationale for each default is in the comments below —
// a migration doc was referenced here but has never existed in this repo.

import { QueryClient } from '@tanstack/react-query';

export function createAppQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // 30s — most dashboard widgets tolerate this. Within the window
        // we dedupe; outside it, a remount triggers a refetch.
        staleTime: 30_000,
        // 5 min — kept > staleTime so data isn't GC'd while still fresh.
        gcTime: 5 * 60_000,
        // Founders tab out a lot; refetch on return so the queue isn't stale.
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
        // Default 3 is too noisy on a slow Cloudflare tunnel.
        retry: 2,
      },
      mutations: {
        // Never silently double-fire writes.
        retry: 0,
      },
    },
  });
}

// Singleton for the SPA. Tests must create their own via createAppQueryClient
// to avoid bleed between cases.
export const queryClient = createAppQueryClient();
